import vuex from 'vuex';
export default {
  modules: {
    navigator: {
      strict: true,
      namespaced: true,
      state: {
        stack: [],
        options: {},
        accessToken: ''
      },
      getters: {
        getAccessToken(state: any) {
          return state.accessToken;
        }
      },
      mutations: {
        push(state: any, page: any) {
          state.stack.push(page);
        },
        pop(state: any) {
          if (state.stack.length > 1) {
            state.stack.pop();
          }
        },
        replace(state: any, page: any) {
          state.stack.pop();
          state.stack.push(page);
        },
        reset(state: any, page: any) {
          state.stack = [page || state.stack[0]];
        },
        options(state: any, newOptions = {}) {
          state.options = newOptions;
        },
        setAccessToken(state: any, payload: string) {
          state.accessToken = payload;
        }
      },
      actions: {
        setAccessToken({ commit }: any, token: string) {
          commit('setAccessToken', token);
        }
      }
    },

    splitter: {
      strict: true,
      namespaced: true,
      state: {
        open: false,
      },
      mutations: {
        toggle(state: any, shouldOpen: any) {
          if (typeof shouldOpen === 'boolean') {
            state.open = shouldOpen;
          } else {
            state.open = !state.open;
          }
        },
      },
    },

    tabbar: {
      strict: true,
      namespaced: true,
      state: {
        index: 1,
      },
      mutations: {
        set(state: any, index: any) {
          state.index = index;
        },
      },
    },
  },
};
